import { useEffect, useState } from 'react';

export interface SimpleUser {
  uid: string;
  email: string;
  role: 'admin' | 'user';
}

const STORAGE_KEY = 'holol_auth_user';

export function getCachedUser(): SimpleUser | null {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
}

export function setCachedUser(user: SimpleUser | null) {
  try {
    if (user) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
    // Dispatch custom event to notify listeners
    window.dispatchEvent(new Event('holol_auth_change'));
  } catch (err) {
    console.error(err);
  }
}

export function useSimpleAuth() {
  const [user, setUser] = useState<SimpleUser | null>(getCachedUser);

  useEffect(() => {
    const handleAuthChange = () => {
      setUser(getCachedUser());
    };
    window.addEventListener('holol_auth_change', handleAuthChange);
    
    // Lazily sync with Firebase if a cached user is found
    if (user) {
      import('./firebase').then(({ auth }) => {
        const unsubscribe = auth.onAuthStateChanged((firebaseUser) => {
          if (firebaseUser) {
            const simple: SimpleUser = {
              uid: firebaseUser.uid,
              email: firebaseUser.email || '',
              role: firebaseUser.email === 'm.0543125382@gmail.com' ? 'admin' : 'user'
            };
            setCachedUser(simple);
          } else {
            setCachedUser(null);
          }
        });
        return unsubscribe;
      }).catch(err => {
        console.error('Lazy auth sync error:', err);
      });
    }

    return () => {
      window.removeEventListener('holol_auth_change', handleAuthChange);
    };
  }, [user?.uid]);

  return user;
}
